import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "How It Works", href: "#how" },
    { label: "Why Us", href: "#benefits" },
    { label: "FAQ", href: "#faq" },
    { label: "Contact", href: "#contact" },
  ];

  const gradientStyle = {
    background: "linear-gradient(135deg, #4F7CFF 0%, #7B8CFF 100%)",
  };
  const gradientHover = {
    background: "linear-gradient(135deg, #3D6AE8 0%, #6B7CE8 100%)",
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={
        scrolled
          ? { backgroundColor: "#FFFFFF", borderBottom: "1px solid #E2E8F0" }
          : { backgroundColor: "transparent" }
      }
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex h-24 md:h-36 items-center justify-between">
          <a
            href="#"
            className="flex items-center"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/edited_24ec1a8935e927938c764a237761f43e_29c252ee.jpg"
              alt="AutoManagement PH Logo"
              className="h-[88px] md:h-[120px] w-auto object-contain"
            />
          </a>

          <nav className="hidden items-center gap-8 md:flex ml-16">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm font-semibold transition cursor-pointer whitespace-nowrap"
                style={{ color: "#475569" }}
                onMouseEnter={(e) =>
                  ((e.target as HTMLElement).style.color = "#1E293B")
                }
                onMouseLeave={(e) =>
                  ((e.target as HTMLElement).style.color = "#475569")
                }
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/intake"
              className="whitespace-nowrap rounded-lg px-5 py-2.5 text-sm font-semibold text-white transition cursor-pointer"
              style={gradientStyle}
              onMouseEnter={(e) =>
                Object.assign((e.target as HTMLElement).style, gradientHover)
              }
              onMouseLeave={(e) =>
                Object.assign((e.target as HTMLElement).style, gradientStyle)
              }
            >
              Book a Free Review
            </Link>
          </nav>

          <button
            className="flex items-center justify-center w-9 h-9 md:hidden cursor-pointer"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <i
              className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`}
              style={{ color: "#1E293B" }}
            />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          className="border-t px-6 py-4 md:hidden"
          style={{ backgroundColor: "#FFFFFF", borderColor: "#E2E8F0" }}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="block py-2 text-sm font-medium cursor-pointer"
              style={{ color: "#475569" }}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/intake"
            onClick={() => setMenuOpen(false)}
            className="mt-3 block rounded-lg px-4 py-2 text-center text-sm font-semibold text-white whitespace-nowrap cursor-pointer"
            style={gradientStyle}
          >
            Book a Free Review
          </Link>
        </div>
      )}
    </header>
  );
}
